var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('router-view'),(_vm.isFullPageLoading)?_c('div',{staticStyle:{"width":"100%","height":"100%","position":"fixed","top":"0","left":"0","z-index":"2000"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }